import { render, staticRenderFns } from "./ListMuralAviso.vue?vue&type=template&id=174999aa&"
import script from "./ListMuralAviso.vue?vue&type=script&lang=js&"
export * from "./ListMuralAviso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports